import {useDeleteRole, useFindAllRoles} from "hooks/query/role-query"
import {useRecoilState} from "recoil"
import {RoleStore} from "store/role-store"
import {RegisterRoleWindow} from "pages/role/RegisterRoleWindow"
import {useNavigate} from "react-router-dom"
import {NotificationType, showNotification} from "common/Notification"

export const RoleListView = () => {
    const [keyword, setKeyword] = useRecoilState(RoleStore.keyword)
    const [showRegisterWindow, setShowRegisterWindow] = useRecoilState(RoleStore.showRegisterWindow)
    const navigate = useNavigate()
    const response = useFindAllRoles()
    const deleteMutate = useDeleteRole()
    const list = response?.data || []

    const deleteRole = (name: string) => {
        if (!window.confirm("삭제하시겠습니까?")) return
        deleteMutate.mutate(name, {
            onSuccess: () => showNotification("Role을 삭제했습니다", NotificationType.SUCCESS),
            onError: () => showNotification("Role삭제가 실패했습니다")
        })
    }

    const goEdit = (name: string) => {
        return () => {
            navigate(`/role/update/${name}/form`)
        }
    }
    return (
        <div className="main-body">
            <div className="level mb0">
                <div className="level-left">
                    <h5 className="is-size-5 has-text-weight-bold ml5">Roles</h5>
                </div>
                <div className="level-right">
                    <div className="level-item input-search-box3 mt5">
                        <div className="btn-search">
                            <i className="fa fa-search"/>
                        </div>
                        <input className="input" type="text" placeholder="검색"
                               defaultValue={keyword} onChange={(e) => setKeyword(e.target.value)}/>
                    </div>
                </div>
            </div>

            <div className="main-panel mb-5">
                <div className="text-right">
                    <div className="button is-purple2 is-size-85" onClick={() => setShowRegisterWindow(true)}>
                        <span className="icon is-small">
                            <i className="fas fa-plus"/>
                        </span>
                        <span>Roles 추가</span>
                    </div>
                </div>

                <div className="grid-table grid-6 mt5">
                    <header className="header">
                        <div className="item">NO</div>
                        <div className="item">Role Name</div>
                        <div className="item">COMPOSITE</div>
                        <div className="item">Description</div>
                        <div className="item">Join Date</div>
                        <div className="item ">note</div>
                    </header>
                    {list.map((role, idx) => {
                        const {name, composite, description, containerId} = role
                        return (
                            <main className="main" key={role.id}>
                                <div className="item">{idx + 1}</div>
                                <div className="item">
                                    <div onClick={goEdit(name)} className="is-clickable">
                                        <span className="has-text-info">{name}</span>
                                    </div>
                                </div>
                                <div className="item">{composite ? "True" : "False"}</div>
                                <div className="item">{description}</div>
                                <div className="item"><span>{containerId}</span></div>
                                <div className="item">
                                    <div className="button  is-info is-inverted is-size-7 mt10"
                                         onClick={goEdit(name)}>
                                        <span className="icon is-small">
                                            <i className="fas fa-pen"/>
                                        </span>
                                        <span>EDIT</span>
                                    </div>
                                    <div className="button  is-danger is-inverted is-size-7 mt10" onClick={() => deleteRole(name)}>
                                        <span className="icon is-small">
                                            <i className="fas fa-trash"/>
                                        </span>
                                        <span>DELETE</span>
                                    </div>
                                </div>
                            </main>
                        )
                    })}
                </div>
            </div>
            {showRegisterWindow && (
                <RegisterRoleWindow close={() => setShowRegisterWindow(false)}/>
            )}
        </div>
    )
}